<div *ngIf="demandeForm" class="row" id="parent-brouillon">
    <form focusInvalidInput [formGroup]="demandeForm">
        <div class="row">
            <div class="col-sm-12" style="display: flex; justify-content: space-between;">
                <h5 class="col-sm-6"> Validation de la demande de {{typeDemande}} N° {{this.demande.code}} {{this.demande.agence ? '(' + this.demande.agence.libelle + ')' : ''}}</h5>
                <div class="col-sm-6" style="justify-content: space-between;">
                    
                    <button color="default" mat-raised-button type="button" (click)="close()">
                        <mat-icon>arrow_back</mat-icon>Retour
                    </button>

                    <button color="warn"  mat-raised-button type="button" (click)="retour()">
                        <mat-icon>not_interested</mat-icon>Retour pour complément
                    </button>

                    <button color="danger"  mat-raised-button type="button" (click)="refus()">
                        <mat-icon>clear</mat-icon>Refuser
                    </button>

                    <button color="success" mat-raised-button type="button" (click)="validate()">
                        <mat-icon>check</mat-icon>Valider
                    </button>

                    <mat-checkbox class="example-margin"  [ngModelOptions]="{standalone: true}" [(ngModel)]="autoNext" (change)="autoChecked($event)">Redirection automatique vers la demande suivante après validation</mat-checkbox>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-9">
                <div class="col-sm-12">
                    <app-demande-form [form]="demandeForm" [agence]="demande.agence"></app-demande-form>
                </div>
                
                <div class="col-sm-12">
                    <app-cycle-validation-list [cyclesValidation]="cyclesValidation"></app-cycle-validation-list>
                </div>
            </div>
            <div class="col-sm-3">
                <app-application-fixed [untouchedApps]="allApplications" [form]="demandeForm" [collabApplications]="collabApplications"></app-application-fixed>
            </div>
        </div>
    </form>
    
</div>
